import * as types from './mutation-types.js'
import api from '../api'
import { getField, updateField } from 'vuex-map-fields'

const downloadExcel = (name, payload) => {
	console.log(name)
	const blob = new Blob([payload], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
	const url = window.URL.createObjectURL(blob)
	const link = document.createElement('a')
	link.href = url
	link.download = name
	document.body.appendChild(link)
	link.click()
	link.parentNode.removeChild(link)
	window.URL.revokeObjectURL(url)
}

const state = {
	userList: {
		data: [],
		total: 0,
		per_page: 10
	},
	userListLoading: false,

	userView: {},
	userViewLoading: false,

	history: [],
	historyLoading: false,

	sleepRecord: [],
	sleepRecordLoading: false,

	card: {},
	cardLoading: false,

	userListExcel: {},
	userListExcelLoading: false,

	userProfileExcel: {},
	userProfileExcelLoading: false,

	reportData: {},
	reportLoading: false,

	calendar: [],
	calendarLoading: false,

	calendarDaily: {
		upmood_meter: 0,
		filepath: ''
	},
	calendarDailyLoading: false,

	downloadFileLoading: false,
	downloadFileData: null,
	downloadForm: {
		date: null,
		time: null
	},

	calendarDate: null,

	countryList: [],
	countryListLoading: false,
	countryKeyword: '',

	lastQueryParams: ''
}

const mutations = {
	updateField,

	[types.GET_USER_LIST] (state) {
		state.userListLoading = true
	},

	[types.GET_USER_LIST_SUCCESS] (state, payload) {
		state.userList = payload
		state.userListLoading = false
	},

	[types.GET_USER_LIST_FAIL] (state, payload) {
		state.userListLoading = false
	},

	[types.GET_EXCEL_FILE] (state) {
		state.userListExcelLoading = true
	},

	[types.GET_EXCEL_FILE_SUCCESS] (state) {
		state.userListExcelLoading = false
	},

	[types.GET_EXCEL_FILE_FAIL] (state, payload) {
		state.userListExcelLoading = false
	},

	[types.GET_USER_CARD] (state) {
		state.userCardLoading = true
	},

	[types.GET_USER_CARD_SUCCESS] (state, payload) {
		state.card = payload
		state.cardLoading = false
	},

	[types.GET_USER_CARD_FAIL] (state, payload) {
		state.userCardLoading = false
	},

	[types.GET_USER_VIEW] (state) {
		state.userViewLoading = true
	},

	[types.GET_USER_VIEW_SUCCESS] (state, payload) {
		state.userView = payload
		state.userViewLoading = false
	},

	[types.GET_USER_VIEW_FAIL] (state, payload) {
		state.userViewLoading = false
	},

	[types.GET_USER_HISTORY] (state) {
		state.history = []
		state.historyLoading = true
	},

	[types.GET_USER_HISTORY_SUCCESS] (state, payload) {
		state.history = payload.data.list
		state.userView.average_emotion = payload.data.average_emotion
		state.userView.average_stress_level = payload.data.average_stress_level
		state.historyLoading = false
	},

	[types.GET_USER_HISTORY_FAIL] (state, payload) {
		state.historyLoading = false
	},

	[types.GET_COUNTRY_LIST] (state) {
		state.countryListLoading = true
	},

	[types.GET_COUNTRY_LIST_SUCCESS] (state, payload) {
		state.countryList = payload.data
		state.countryListLoading = false
	},

	[types.GET_COUNTRY_LIST_FAIL] (state, payload) {
		state.countryListLoading = false
	},

	[types.GET_USERPROFILE_EXCEL] (state) {
		state.downloadFileLoading = true
	},

	[types.GET_USERPROFILE_EXCEL_SUCCESS] (state, payload) {
		state.downloadFileLoading = false
	},

	[types.GET_USERPROFILE_EXCEL_FAIL] (state, payload) {
		state.downloadFileLoading = false
	},

	[types.GET_REPORT] (state) {
		state.reportLoading = true
	},

	[types.GET_REPORT_SUCCESS] (state, payload) {
		state.reportData = payload.data
		state.reportLoading = false
	},

	[types.GET_REPORT_FAIL] (state, payload) {
		state.reportLoading = false
	},

	[types.DEACTIVATED] (state, payload) {
		state.userList = {}
		state.userListLoading = false
	},

	[types.DEACTIVATED_USER_VIEW] () {
		state.userView = {}
		state.userViewLoading = false
		state.history = {}
		state.historyLoading = false
	},

	[types.GET_CALENDAR] (state) {
		state.calendarLoading = true
	},

	[types.GET_CALENDAR_SUCCESS] (state, payload) {
		state.calendar = payload
		state.calendarLoading = false
	},

	[types.GET_CALENDAR_FAIL] (state, payload) {
		state.calendar = payload
		state.calendarLoading = false
	},

	[types.GET_DAILY] (state) {
		state.calendarDailyLoading = true
	},

	[types.GET_DAILY_SUCCESS] (state, payload) {
		state.calendarDaily = payload
		state.calendarDailyLoading = false
	},

	[types.GET_DAILY_FAIL] (state, payload) {
		state.calendarDaily = payload
		state.calendarDailyLoading = false
	  }
}

const actions = {

	async getUserList ({ commit }, payload) {
		commit(types.GET_USER_LIST)

		const { data, status } = await api('get', `/user/list${payload}`)

		if (status) {
			commit(types.GET_USER_LIST_SUCCESS, data.data)
			return
		}

		commit(types.GET_USER_LIST_FAIL, data)
	},

	async downloadUserListExcel ({ commit }, payload) {
		commit(types.GET_EXCEL_FILE)

		// const { data } = await api('get', `/user/excel${payload}`, null, true)
		const { data } = await api('post', `/user/excel`, payload, true)

		downloadExcel('User List.xlsx', data)
		commit(types.GET_EXCEL_FILE_SUCCESS)
	},

	async getCard ({ commit }, payload) {
		commit(types.GET_USER_CARD)

		const { data, status } = await api('get', `/user/cards${payload}`)

		if (status) {
			commit(types.GET_USER_CARD_SUCCESS, data.data)
			return
		}

		commit(types.GET_USER_CARD_FAIL, data)
	},

	async viewUser ({ commit }, payload) {
		commit(types.GET_USER_VIEW)
		const { data, status } = await api('get', `/user/view?id=${payload}`)
		if (status) {
			commit(types.GET_USER_VIEW_SUCCESS, data.data)
			return
		}

		commit(types.GET_USER_VIEW_FAIL, data)
	},

	async getAverage ({ commit }, payload) {
		state.historyLoading = true
		const { data, status } = await api('get', `/user/view` + payload)
		if (status) {
			state.userView.average_emotion = data.data.average_emotion
			state.userView.average_stress_level = data.data.average_stress_level
			state.historyLoading = false
			return
		}

		state.historyLoading = false
	},

	async getHistory ({ commit }, payload) {
		commit(types.GET_USER_HISTORY)

		const { data, status } = await api('get', `/user/history${payload}`)

		if (status) {
			commit(types.GET_USER_HISTORY_SUCCESS, data)
			return
		}

		commit(types.GET_USER_HISTORY_FAIL, data)
	},

	async downloadUserProfileExcel ({ state, commit, dispatch }, payload) {
		commit(types.GET_USERPROFILE_EXCEL)

		const { data } = await api('post', '/user/excel-userprofile', payload, true)

		if (data.type === 'application/json') {
			dispatch('toggleBanner', {
				status: true,
				message: 'No record found!',
				type: 'invalid'
			}, { root: true })
			commit(types.GET_USERPROFILE_EXCEL_FAIL)
			return
		}
		downloadExcel(`${state.userView.name}.xlsx`, data)
		commit(types.GET_USERPROFILE_EXCEL_SUCCESS)
	},

	async getUserProfileDetails ({ dispatch }, payload) {
		state.downloadFileLoading = true

		const { data, status } = await api('post', '/user/report', payload)

		dispatch('closeModal', {}, { root: true })

		if (!(status && data.status === 200)) {
			dispatch('toggleBanner', {
				status: true,
				message: 'No record found!',
				type: 'invalid'
			}, { root: true })
			state.downloadFileData = null
			state.downloadFileLoading = false

			return
		}

		state.downloadFileData = data
		state.downloadFileLoading = false
	},

	async getReport ({ commit }, payload) {
		commit(types.GET_REPORT)

		const { data, status } = await api('post', '/user/report', payload)

		if (status) {
			commit(types.GET_REPORT_SUCCESS, data)
		}

		commit(types.GET_REPORT_FAIL, data)
	},

	async getCalendar ({ commit }, payload) {
		commit(types.GET_CALENDAR)

		const { data, status } = await api('get', `/user/calendar${payload}`)

		if (status) {
			commit(types.GET_CALENDAR_SUCCESS, data.data)
			return
		}

		commit(types.GET_CALENDAR_FAIL, data.data)
	},

	async getDailyCalendar ({ commit }, payload) {
		commit(types.GET_DAILY)

		const { data, status } = await api('get', `/user/daily${payload}`)

		if (status) {
			commit(types.GET_DAILY_SUCCESS, data.data)
			return
		}

		commit(types.GET_DAILY_FAIL, data.data)
	},

	async getCountryList ({ state }) {
		state.countryListLoading = true

		const { data, status } = await api('get', `user/country`)

		if (status) {
			state.countryList = data.data
			state.countryListLoading = false
			return
		}

		state.countryListLoading = false
	},

	async getSleepRecord ({ state }, payload) {
		state.sleepRecordLoading = true
		const { data, status } = await api('get', `/user/sleep-record${payload}`)
		if (status) {
			state.sleepRecord = data.data
			state.sleepRecordLoading = false
			return
		}

		state.sleepRecordLoading = false
	}

}

const getters = {
	getField,

	getUserList: state => state.userList,
	getUserListLoading: state => state.userListLoading,

	getUserListExcel: state => state.userListExcel,
	getUserListExcelLoading: state => state.userListExcelLoading,

	getUserView: state => state.userView,
	getUserViewLoading: state => state.userViewLoading,

	getHistory: state => state.history,
	getHistoryLoading: state => state.historyLoading,

	getSleepRecord: state => state.sleepRecord,
	getSleepRecordLoading: state => state.sleepRecordLoading,

	getCard: state => state.card,
	getCardLoading: state => state.cardLoading,

	getCountryList: state => state.countryList,
	getCountryListLoading: state => state.countryListLoading,

	getUserProfileExcel: state => state.userProfileExcel,
	getUserProfileExcelLoading: state => state.userProfileExcelLoading,

	getReportData: state => state.reportData,
	getReportLoading: state => state.reportLoading,

	getCalendar: state => state.calendar,
	getCalendarLoading: state => state.calendarLoading,

	getDaily: state => state.calendarDaily,
	getDailyLoading: state => state.calendarDailyLoading
}

export default {
	state,
	namespaced: true,
	mutations,
	actions,
	getters
}
